/* eslint-disable react/prop-types */
import React from "react";
import {
  Box,
  Pagination,
  FormControl,
  Select,
  MenuItem,
  Typography,
} from "@mui/material";

const CustomPagination = ({
  page,
  rowsPerPage,
  totalRecords,
  onPageChange,
  onRowsPerPageChange,
}) => {
  const totalPages = Math.ceil(totalRecords / rowsPerPage);

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={2}
      flexWrap="wrap"
      gap={2}
    >
      <Typography variant="body2">
        Total Records: {totalRecords}
      </Typography>

      <Pagination
        page={page}
        count={totalPages}
        color="primary"
        onChange={(event, value) => onPageChange(value)}
      />

      <Box display="flex" alignItems="center" gap={1}>
        <Typography variant="body2">Rows:</Typography>
        <FormControl size="small">
          <Select
            value={rowsPerPage}
            onChange={(e) => onRowsPerPageChange(Number(e.target.value))}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
      </Box>
    </Box>
  );
};

export default CustomPagination;